// extracted by mini-css-extract-plugin
module.exports = {"news-article":"News_news-article__1pi7H","img-handler":"News_img-handler__1S89n","news-text":"News_news-text__2VkJR","news-text__info":"News_news-text__info__piH0h"};